import { WarningNotice } from "../components/Game/WarningNotice.tsx";

import { WarningNoticeLong } from "../components/Game/WarningNoticeLong.tsx";

export default WarningNotice;

export { WarningNoticeLong };